import React, { useState, useEffect, useRef } from 'react';
import { Send, Smile, Image, Paperclip, ArrowLeft, Settings } from 'lucide-react';

import { useNavigate } from 'react-router-dom';

const Soni = () => {
    const navigate = useNavigate();
  const [messages, setMessages] = useState([
    {
      type: 'bot',
      content: 'Bonjour! 👋 Je suis Soni, je vais vous aider à remplir ce formulaire de manière simple et conviviale.',
      options: ['Commencer', 'En savoir plus']
    }
  ]);
  const [userInput, setUserInput] = useState('');
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const chatEndRef = useRef(null);

  const questions = [
    {
      question: "Comment vous appelez-vous ?",
      type: "text"
    },
    {
      question: "Quel est votre objectif principal ?",
      type: "options",
      options: ["Développement personnel", "Carrière", "Santé", "Autre"]
    },
    {
      question: "Sur une échelle de 1 à 5, à quel point êtes-vous motivé(e) ?",
      type: "rating"
    }
  ];

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = () => {
    if (!userInput.trim()) return;

    // Ajouter le message de l'utilisateur
    setMessages(prev => [...prev, {
      type: 'user',
      content: userInput
    }]);

    // Simuler la réponse du bot
    setTimeout(() => {
      if (currentQuestion < questions.length) {
        setMessages(prev => [...prev, {
          type: 'bot',
          content: questions[currentQuestion].question,
          questionType: questions[currentQuestion].type,
          options: questions[currentQuestion].options
        }]);
        setCurrentQuestion(prev => prev + 1);
      }
    }, 1000);

    setUserInput('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-purple-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-lg px-4 py-3 flex items-center justify-between border-b border-gray-200 sticky top-0 z-10">
        <div className="flex items-center space-x-4">
          <button className="p-2 hover:bg-gray-100 rounded-full transition-colors">
            <ArrowLeft className="w-5 h-5 text-gray-600" />
          </button>
          <div>
            <h1 onClick={()=>{

navigate("/Plans");
            }} className="text-lg font-semibold text-gray-900">Formulaire interactif</h1>
            <p className="text-sm text-gray-500">avec Soni</p>
          </div>
        </div>
        <button className="p-2 hover:bg-gray-100 rounded-full transition-colors">
          <Settings className="w-5 h-5 text-gray-600" />
        </button>
      </header>

      {/* Chat Container */}
      <main className="max-w-2xl mx-auto px-4 py-6">
        <div className="space-y-6 mb-20">
          {messages.map((message, index) => (
            <div
              key={index}
              className={`flex ${message.type === 'user' ? 'justify-end' : 'justify-start'}`}
            >
              <div
                className={`max-w-[80%] rounded-2xl p-4 ${
                  message.type === 'user'
                    ? 'bg-blue-600 text-white'
                    : 'bg-white shadow-sm'
                }`}
              >
                <p className="text-[15px]">{message.content}</p>

                {/* Options de réponse */}
                {message.options && (
                  <div className="mt-3 space-y-2">
                    {message.options.map((option, idx) => (
                      <button
                        key={idx}
                        className="block w-full text-left px-4 py-2 rounded-xl bg-gray-50 text-gray-700 hover:bg-gray-100 transition-colors"
                        onClick={() => {
                          setMessages(prev => [...prev, {
                            type: 'user',
                            content: option
                          }]);
                        }}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                )}

                {/* Rating System */}
                {message.questionType === 'rating' && (
                  <div className="mt-3 flex gap-2">
                    {[1, 2, 3, 4, 5].map((num) => (
                      <button
                        key={num}
                        className="w-10 h-10 rounded-full bg-gray-50 hover:bg-gray-100 text-gray-700 flex items-center justify-center transition-colors"
                        onClick={() => {
                          setMessages(prev => [...prev, {
                            type: 'user',
                            content: `${num}/5`
                          }]);
                        }}
                      >
                        {num}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
          <div ref={chatEndRef} />
        </div>
      </main>

      {/* Input Area */}
      <footer className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
        <div className="max-w-2xl mx-auto p-4">
          <div className="flex items-center space-x-4">
            <button className="p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors">
              <Paperclip className="w-5 h-5" />
            </button>
            <button className="p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors">
              <Image className="w-5 h-5" />
            </button>
            <div className="flex-1 bg-gray-100 rounded-2xl flex items-center">
              <input
                type="text"
                placeholder="Écrivez votre message..."
                className="flex-1 px-4 py-3 bg-transparent outline-none"
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <button className="p-2 text-gray-500 hover:bg-gray-200 rounded-full transition-colors mx-1">
                <Smile className="w-5 h-5" />
              </button>
            </div>
            <button
              onClick={handleSend}
              className={`p-3 rounded-xl transition-colors ${
                userInput.trim()
                  ? 'bg-blue-600 text-white hover:bg-blue-700'
                  : 'bg-gray-100 text-gray-400'
              }`}
            >
              <Send className="w-5 h-5" />
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Soni;